import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UserLatestNotifications } from "@assets/types";
import NotificationService from "@services/NotificationService";
import { RootState } from "@state/store";

export const getLatestNotifications = createAsyncThunk(
  "notifications/latest",
  () => NotificationService.getLatestNotifications()
);
export interface NotificationsState {
  notifications?: UserLatestNotifications;
}

export const initialNotificationsState: NotificationsState = {
  notifications: undefined,
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState: initialNotificationsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLatestNotifications.rejected, (state) => {
        state.notifications = undefined;
      })
      .addCase(
        getLatestNotifications.fulfilled,
        (state, action: PayloadAction<UserLatestNotifications>) => {
          state.notifications = action.payload;
        }
      );
  },
});

export const notificationsState = (state: RootState) =>
  state.notificationsSlice;

export default notificationsSlice.reducer;
